const parseStaffResponse = staff => {
    const data = {};
    staff.forEach(item => {
        data[item.uid] = { ...item };
    });
    return data;
};

export default parseStaffResponse;
